import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

//Components and Layout
import MainLayout from "../../layout/mainlayout.tsx";
import Profile from "../../components/Profile/Profile.tsx";
import ContentHeader from "../../components/ContentHeader/ContentHeader.tsx";
import Card from "../../components/Card/Card.tsx";
import TicketList from "../../components/TicketList/TicketList.tsx";

//CSS
import "./Dashboard.css";
import { useGetAllTicketsQuery } from "../../services/ticket.api.ts";

//Charts
import SummaryBoxes from "../../components/chart_components/SummaryBoxes/SummaryBoxes.tsx";
import TicketCreationByDays from "../../components/chart_components/TicketCreationByDays/TicketCreationByDays.tsx";
import TicketsByCategory from "../../components/chart_components/TicketsByCategory/TicketsByCategory.tsx";
import TicketsByStatus from "../../components/chart_components/TicketsByStatusPercentage/TicketsByStatusPercentage.tsx";
import MiniCreateTicket from "../../components/MiniCreateTicketComponent/MiniCreateTicket.tsx";

// hooks
import { useAppSelector } from "../../app/hooks.ts";
import { selectAuth } from "../../features/authSlice.ts";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { data: tickets, isLoading: isTicketLoading, isError: isTicketError } = useGetAllTicketsQuery();

  const {agentData} = useAppSelector(selectAuth);

  return (
    <MainLayout>
      <div className="dashboard--content">
        <ContentHeader>Welcome to your Dashboard, {agentData?.agent_username}!</ContentHeader>

        <div className="top-content">
          <div className="left-top-content">
            <div className="card-div">
              <Card />
            </div>
            <div className="recent-tickets-list">
              <div className="list--header">
                  <h2>Recent Tickets</h2>
                  <div className="create-ticket">
                    <Link to={'/create-ticket'} className="create-button">
                      <span>Create Ticket</span>
                    </Link>
                  </div>
              </div>

              <div className="summary-boxes">
                <SummaryBoxes />
              </div>
              

              {/* TicketList Section */}
              {isTicketLoading && <div>Loading tickets...</div>}
              {isTicketError && <div>Error loading tickets</div>}
              {!isTicketLoading && !isTicketError && (
                <TicketList tickets={tickets || []}>
                5
                </TicketList>
              )}
              <p className="view-more-tickets">View more..</p>
            </div>
          </div>
          <div className="right-top-content">
            <div className="create-ticket-short">
              <MiniCreateTicket />
            </div>
            {/* <Profile/> */}
          </div>
        </div>
        <div className="ticket-by-dayofweek">
          <TicketCreationByDays />
        </div>
        <div className="pie-charts">
          <TicketsByCategory />
          <TicketsByStatus />
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
